import {
  SoftwareManagementGetSoftwareSetupsDocument,
  SoftwareManagementUpdateSoftwareSetupDocument,
  SoftwareManagementUpdateSoftwareSetupMutation,
  SoftwareManagementUpdateSoftwareSetupMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateSoftwareSetup = () => {
  const [updateSoftwareSetup, { loading }] = useMutation(
    SoftwareManagementUpdateSoftwareSetupDocument,
    {
      extractorFn: (data: SoftwareManagementUpdateSoftwareSetupMutation) =>
        data.softwareManagementMutations.updateSoftwaremanagementSoftwareSetup,
    }
  )

  return {
    updateSoftwareSetup(
      variables: SoftwareManagementUpdateSoftwareSetupMutationVariables,
      companyId: string
    ) {
      return updateSoftwareSetup({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: SoftwareManagementGetSoftwareSetupsDocument,
            variables: { ids: [variables.id], companyId: companyId },
          },
        ],
      })
    },
    loading,
  }
}
